import HeroWedding from 'shared/lib/assets/img/landing/hero-wedding.png';
import LogoNationwide from 'shared/lib/assets/img/logo/logo-nationwide.svg';

export const weddingConfig = {
  hero: {
    heading: 'Protection for the happiest day of your life',
    subheading:
      'You’ve got the rings, you booked the band—now ensure all of your planning and worrying pays off.',
    cta: 'Get wedding insurance',
    ctaLink: '/wedding-protection',
    img: HeroWedding,
  },
  underwriter: {
    img: LogoNationwide,
    name: 'Nationwide',
  },
  coverageDetails: [
    {
      heading: 'Cancellation/Postponement of Event',
      subheading:
        'Coverage provides reimbursement for losses and expenses, resulting from: severe weather, sudden illness, no-show vendors, damage to attire, photos or gifts.',
    },
    {
      heading: 'Wedding Liability Coverage',
      subheading:
        'Protects you if you’re held liable for property damage or bodily injury. Offers host liquor liability to protect against alcohol-related accidents.',
    },
  ],
  scenarioDetails: {
    heading: 'Why Would You Need Wedding Insurance?',
    scenarios: [
      {
        heading: 'Scenario 1',
        subheading:
          'You thought your puppy carrying the rings down the aisle was a good idea – but now they are nowhere to be found.',
      },
      {
        heading: 'Scenario 2',
        subheading:
          'Uncle Dom has had a bit too much champagne and stage dives off the DJ booth – face first.',
      },
      {
        heading: 'Scenario 3',
        subheading:
          'You’ve always dreamed about a wedding in your grandmother’s rose garden. Now the vendors are arriving the same time as the rain.',
      },
      {
        heading: 'Scenario 4',
        subheading:
          'Your flaky friend from college actually showed up to your wedding. Surprisingly, your fiance did not.',
      },
    ],
  },
  comparison: [
    'Instant quote',
    'Buy and manage your policy in one place',
    'Insurance explained in simple, easy-to-digest way',
    'Mobile',
    'Endorsements',
    'Plan tailored to fit your needs',
  ],
};
